export const imageProvider = (baseApiUrl, tranportationApiUrl) => ({
    providers: {
        imageProvider: {
            name: 'imageProvider',
            provider: `${__dirname, '..'}/providers/imageProvider`,
            options: {
                modifiers: {
                    format: 'webp',
                    // quality: 100
                },
                screens: {
                    xs: 320,
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1200,
                },
                baseURL: `${baseApiUrl}storage/image/`,
            },
        },
        imageProviderTranportation: {
            name: 'imageProviderTranportation',
            provider: `${__dirname, '..'}/providers/imageProvider`,
            options: {
                modifiers: {
                    format: 'webp',
                    // quality: 100
                },
                screens: {
                    xs: 320,
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1200,
                },
                baseURL: `${tranportationApiUrl}/storage/image/`,
            },
        },
    },
    provider: 'imageProvider',
});
